import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/use_auth";

const ProtectedRoute = () => {
  const user = useAuth();
  const navigate = useNavigate();

  if (!user) {
    navigate.push("/login");
  }

  return (
    <div>
      <h2>Protected Content</h2>
      <p>Only accessible to logged-in users.</p>
    </div>
  );
};

export default ProtectedRoute;
